import { combineReducers } from "redux";

import registrationData from "./registrationData";

const rootReducer = combineReducers({
  registrationData: registrationData,
});

export default rootReducer;
